import { Order } from '../types/order';

export const roomSelectorErrors = (order: Order): string[] => {
  const errors: string[] = [];
  
  if (!order.order_rooms || order.order_rooms.length === 0) {
    errors.push('At least one room must be selected.');
    return errors;
  }

  order.order_rooms.forEach((room, index) => {
    if (room.conference_hotel_room === undefined) {
      errors.push(`Room ${index + 1} is missing a selected hotel room.`);
    }
    if (!room.arrivalDate) {
      errors.push(`Room ${index + 1} is missing an arrival date.`);
    }
    if (!room.departureDate) {
      errors.push(`Room ${index + 1} is missing a departure date.`);
    }
    
  });
  console.error(errors)
  return errors;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
  return phoneRegex.test(phone);
};

export const validateRequired = (value: string | null | undefined): boolean => {
  return Boolean(value && value.trim().length > 0);
};